import React from 'react';
import styled from 'styled-components';
import logoFull from '../../assets/logo.png';

const Page = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
  display: flex;
  flex-direction: column;
`;

const TopBar = styled.header`
  background: ${({ theme }) => theme.colors.surface};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LogoImg = styled.img`
  height: 28px;
  cursor: pointer;
`;

const BackLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  transition: color 0.15s;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const Content = styled.main`
  flex: 1;
  max-width: 760px;
  width: 100%;
  margin: 0 auto;
  padding: 3rem 1.5rem 5rem;

  @media (max-width: 640px) {
    padding: 2rem 1.25rem 4rem;
  }
`;

export const LegalPageTitle = styled.h1`
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: 2.1rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0 0 0.5rem;
`;

export const LegalPageUpdated = styled.p`
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0 0 2.5rem;
`;

export const LegalNotice = styled.div`
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  padding: 0.9rem 1.1rem;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: 0.85rem;
  line-height: 1.55;
  color: #9a3412;
  margin: 0 0 2.5rem;
`;

export const LegalSection = styled.section`
  margin-bottom: 2.25rem;
`;

export const LegalHeading = styled.h2`
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: 1.15rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0 0 0.75rem;
`;

export const LegalBody = styled.p`
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: 0.95rem;
  line-height: 1.75;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0 0 0.9rem;
`;

export const LegalList = styled.ul`
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: 0.95rem;
  line-height: 1.75;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0 0 0.9rem;
  padding-left: 1.3rem;

  li {
    margin-bottom: 0.4rem;
  }
`;

export interface LegalPageLayoutProps {
  onBack: () => void;
  children: React.ReactNode;
}

export const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ onBack, children }) => {
  return (
    <Page>
      <TopBar>
        <LogoImg src={logoFull} alt="Tvikla" onClick={onBack} />
        <BackLink onClick={onBack}>&larr; Back</BackLink>
      </TopBar>
      <Content>{children}</Content>
    </Page>
  );
};
